<script setup>
import { Link } from '@inertiajs/inertia-vue3'
</script>
<template>

    <Head>
        <title>Consulta Pública</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-secretarias-direcciones.png');">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Consulta Pública</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="bloque-general">
        <div class="container">
            <div class="col-12">
                <div class="row">
                    <div class="col-lg-2 text-center text-md-left mb-4"><img :src="'/storage/' + seccion.imagen" alt="" loading="lazy" /></div>
                    <div class="col-lg-10 contenido-administrable text-center text-md-left" v-html="seccion.descripcion"></div>
                </div>
                <div class="row">
                    <div class="row mt-5 mt-s-4">
                        <div class="col-lg-4 col-md-6 col-12" v-for="(item, index) in secciones" :key="index">
                            <a :href="route('consulta.seccion', item.slug)" class="item">
                                <img :src="'/storage/' + item.imagen" alt="" loading="lazy" />
                                <div class="title">{{ item.nombre }}</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
    },
    props: {
        seccion: Object,
        secciones: Object,
    },
}
</script>
<style scoped>
.item {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 200px;
    border-radius: 20px;
    border: 1px solid #979797;
    padding-left: 40px;
    padding-right: 40px;
    text-align: center;
    margin-bottom: 20px;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    box-shadow: 4px 4px 8px 0px rgb(0 0 0 / 17%);
    color: #000;
}

.item:hover {
    color: #B29966;
}

.item img {
    width: 65px;
    display: block;
    margin-bottom: 20px;
}

.item:hover img {
    transition: 0.5s;
    filter: brightness(0) saturate(100%) invert(72%) sepia(11%) saturate(1278%) hue-rotate(3deg) brightness(86%) contrast(82%);
}

.item .title {
    line-height: 1.1em;
}
</style>
